<template>
    <div>
        <img src="/webroot/images/lifeguard.png" height="42" width="42">
        <p class="note-text">
            <slot></slot>
        </p>
    </div>
</template>

<script>
    export default {
        name: "SafeGuardBoxRed"
    }
</script>

<style scoped>
    .note-text {
        color: #383838;
        font-family: "Source Sans Pro";
        font-size: 18px;
        line-height: 22px;
        margin-left: 50px;
    }

    img {
        float: left;
        margin-top: 25px;
    }
</style>
